import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=6b6291a7&scoped=true&"
import script from "./MessageForm.vue?vue&type=script&lang=js&"
export * from "./MessageForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=6b6291a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6291a7",
  null
  
)

export default component.exports